<template>
  <div class="Box">
    <el-container style="height: 100%;" direction="vertical">
      <el-header>APM 网站发布系统</el-header>
      <el-container>
        <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
          <el-menu  default-active="2">
            <el-menu-item index="1" @click="JumpToPage('shouye')">
              首页
            </el-menu-item>
            <el-menu-item index="2" @click="JumpToPage('wozaiqiye')">
              我在企业
            </el-menu-item>
            <el-menu-item index="3">企业面板</el-menu-item>
            <el-menu-item index="4">项目实施</el-menu-item>
            <el-menu-item index="5">企业采购</el-menu-item>
            <el-menu-item index="6">企业仓库</el-menu-item>
            <el-menu-item index="7">企业设置</el-menu-item>
            <el-menu-item index="8">企业应用</el-menu-item>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </el-main>
          <el-footer>
            © 2019 新线程 苏ICP备19007702号</el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
  export default {
    name: '',
    data(){
      return {

      }
    },
    components: {

    },
    computed:{

    },
    methods:{
      JumpToPage(url) {
        this.$router.push({
          path: "/ReleaseContent/" + url
        })
      }
    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style>
  .Box{
    height: 100%;
  }
  .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  .el-header{
    background-color:#007aff;
    color:#fff;
    font-size:17px;
  }
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }

  body > .el-container {
    width:100%;
    height: 100%;
    padding: 0;
    margin: 0;
  }
  .el-menu{
    height: 100%;
  }
</style>
